<script setup lang="ts">
// import EstateListingSortDropdown from './EstateListingSortDropdown.vue'
import Icon from '~/components/global/Icon.vue'
import Container from '~/components/layout/Container.vue'
import type {
  EstateListingResponse,
  EstateType,
} from '~/types/api/EstateListing'

const props = defineProps<{
  officesResponse: EstateListingResponse | null
  officesPending: boolean
  estateType: EstateType
}>()

const mapListingLink = computed(() => {
  try {
    const { query } = useRoute()
    const { filter } = query
    const parsedFilter = JSON.parse(
      decodeURIComponent(filter?.toString() || '') || '{}'
    )

    delete parsedFilter.latitude_from
    delete parsedFilter.latitude_to
    delete parsedFilter.longitude_from
    delete parsedFilter.longitude_to

    return getEstateListingLink({
      estateType: props.estateType,
      listingType: 'map',
      query: {
        filter: encodeURIComponent(JSON.stringify(parsedFilter)),
      },
    })
  } catch (error) {}

  return getEstateListingLink({
    estateType: props.estateType,
    listingType: 'map',
  })
})
</script>

<template>
  <div class="c-estate-listing-sort">
    <Container class="c-estate-listing-sort__container">
      <!-- <EstateListingSortDropdown class="c-estate-listing-sort__dropdown" /> -->

      <div class="c-estate-listing-sort__count">
        <template v-if="!officesResponse && officesPending">
          <span class="sc-skeleton" />
        </template>

        <template v-else-if="officesResponse">
          {{
            $t(
              'pages.estateListing.sort.offersDisplayed',
              {
                _0: officesResponse.count,
              },
              officesResponse.count
            )
          }}
        </template>
      </div>

      <div class="c-estate-listing-sort__map-link">
        <IButton class="has-icon" color="primary" :to="mapListingLink">
          <Icon name="pin-map" />

          <span class="_sm:visible">{{
            $t('pages.estateListing.viewOnMapLong')
          }}</span>
          <span class="_sm:hidden">{{
            $t('pages.estateListing.viewOnMap')
          }}</span>
        </IButton>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;
@use '@/assets/styles/mixins/skeleton' as skeleton;

.c-estate-listing-sort {
  &__container {
    display: flex;
    align-items: center;
    gap: 32px;

    @include breakpoint-down('sm') {
      display: grid;
      grid-template:
        'dropdown count' auto
        'map-link map-link' auto
        / 1fr auto;
      gap: 12px;
    }
  }

  &__dropdown {
    grid-area: dropdown;
  }

  &__count {
    grid-area: count;
    font-size: 16px;
    line-height: 1.2;

    .sc-skeleton {
      @include skeleton.skeleton;

      display: block;
      width: 150px;
      height: 1.2em;
      border-radius: 2px;
    }

    @include breakpoint-down('sm') {
      font-size: 14px;
    }
  }

  &__map-link {
    grid-area: map-link;
    margin-left: auto;

    @include breakpoint-down('sm') {
      width: 100%;
    }

    .button {
      --button--padding-left: 28px;
      --button--padding-right: 28px;
      min-height: 52px;
      font-weight: 500;

      @include breakpoint-down('sm') {
        width: 100%;
      }
    }
  }
}
</style>
